const e = {};
export {
  e as default
};
//# sourceMappingURL=index.es302.js.map
